import React from 'react'
import { useLanguage } from '@/lib/lang'
import { t } from '@/lib/i18n'
import { PrimaryBanner } from './layout/PrimaryBanner'

export const HomeHero = () => {
  const { lang } = useLanguage()

  return (
    <div className="home-primary-banner-sticky sticky top-0 z-40 bg-transparent sm:bg-background shadow-none sm:shadow-sm transition-all duration-300">
      <PrimaryBanner
        title={t('title', lang)}
        subtitle={null}
      />
    </div>
  )
}
